import Decimal from 'decimal.js';

import { RULE_IDS, type InspectionSettings, type RuleId } from './types';

const DEFAULT_RULE_SWITCHES = Object.fromEntries(RULE_IDS.map((id) => [id, true])) as Record<
  RuleId,
  boolean
>;

export const DEFAULT_INSPECTION_SETTINGS: InspectionSettings = Object.freeze({
  enabledRules: Object.freeze(DEFAULT_RULE_SWITCHES),
  amountTolerance: Object.freeze({ absolute: '0.01', relative: '0.0001' }),
  priceDeviationThreshold: '0.5',
  minimumDescriptionLength: 2,
});

export function mergeInspectionSettings(
  settings?: Partial<InspectionSettings>,
): InspectionSettings {
  return {
    enabledRules: {
      ...DEFAULT_INSPECTION_SETTINGS.enabledRules,
      ...settings?.enabledRules,
    },
    amountTolerance: {
      ...DEFAULT_INSPECTION_SETTINGS.amountTolerance,
      ...settings?.amountTolerance,
    },
    priceDeviationThreshold:
      settings?.priceDeviationThreshold ?? DEFAULT_INSPECTION_SETTINGS.priceDeviationThreshold,
    minimumDescriptionLength:
      settings?.minimumDescriptionLength ?? DEFAULT_INSPECTION_SETTINGS.minimumDescriptionLength,
  };
}

export function validateInspectionSettings(settings: InspectionSettings): readonly string[] {
  const messages: string[] = [];
  if (!isNonNegativeDecimal(settings.amountTolerance.absolute)) {
    messages.push('固定金额容差必须是大于或等于 0 的有效数字。');
  }
  if (!isNonNegativeDecimal(settings.amountTolerance.relative)) {
    messages.push('相对金额容差必须是大于或等于 0 的有效数字。');
  }
  if (!isNonNegativeDecimal(settings.priceDeviationThreshold)) {
    messages.push('价格偏离阈值必须是大于或等于 0 的有效数字。');
  }
  if (
    !Number.isInteger(settings.minimumDescriptionLength) ||
    settings.minimumDescriptionLength < 0
  ) {
    messages.push('项目特征最小长度必须是大于或等于 0 的整数。');
  }
  return messages;
}

function isNonNegativeDecimal(value: string): boolean {
  if (value.trim().length === 0) return false;
  try {
    const decimal = new Decimal(value);
    return decimal.isFinite() && !decimal.isNegative();
  } catch {
    return false;
  }
}
